import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

export enum NotificationType {
  SUCCESS = 'success',
  ERROR = 'error',
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly snackBar = inject(MatSnackBar);
  private readonly translateService = inject(TranslateService);

  public success(message: string, duration?: number): MatSnackBarRef<TextOnlySnackBar> {
    return this.show(message, NotificationType.SUCCESS, duration);
  }

  public error(message: string, duration?: number): MatSnackBarRef<TextOnlySnackBar> {
    return this.show(message, NotificationType.ERROR, duration);
  }

  private show(message: string, type: NotificationType = NotificationType.ERROR, duration: number = 3000): MatSnackBarRef<TextOnlySnackBar> {
    const translatedMessage = this.translateService.instant(message);
    return this.snackBar.open(translatedMessage, 'x', {
      panelClass: [`${type}-snackbar`],
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: duration,
    });
  }
}